export default __webpack_public_path__ + "static/media/AccessibleGames_RC1204.54690750.pdf";